// extracted by mini-css-extract-plugin
module.exports = {"container":"App_container__aw4VH","title":"App_title__qd8yW","contacts":"App_contacts__3MSzu"};